import styled from "styled-components";

interface IStyled {
  width?: string;
}

export const StyledRegions = styled.div<IStyled>`
  gap: 2rem;
  flex-wrap: wrap;
  width: ${(props) => props.width || "100%"};

  & > * {
    flex: 1 1 20rem;
    width: 100%;
  }

  label,
  select {
    display: block;
    width: 100%;
  }

  label {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 1.4rem;
    /* line-height: 1%.7rem; */
    color: var(--light-1);
    margin-bottom: 0.6rem;
  }

  select {
    appearance: none;
    outline: none;
    background-color: var(--white);
    font-size: 1.5rem;
    line-height: 1.5rem;
    margin-top: 0.8rem;
    font-weight: 400;
    color: var(--dark-3);
    padding: 1.6rem;
    box-shadow: 0rem 0.1rem 0.2rem rgba(50, 50, 71, 0.08),
      0rem 0rem 0.1rem rgba(50, 50, 71, 0.2);
    border-radius: 0.6rem;
    border: 0.1rem solid transparent;
    display: flex;
    color: var(--light-2);
    position: relative;
  }

  .select--container {
    position: relative;
    color: var(--light-2);

    &::after {
      content: "▼";
      font-size: 1.5rem;
      top: 0rem;
      right: 1rem;
      position: absolute;
      transform: translate(0%, 50%);
    }
  }

  .error {
    color: var(--error);
    font-size: 1.4rem;
    text-align: left;
    margin-top: 0.8rem;
    font-weight: 500;
    display: inline-block;
  }
`;
